import { formatarDataHora } from "../../../utils/solicitacoes/formatters";

// Espelha StatusPrazo (backend) — cálculo do prazo é feito 100% no backend (SolicitacaoService#
// calcularPrazoEtapa), este componente só renderiza o resultado já pronto em `solicitacao.prazoEtapa`.
const STATUS_INFO = {
    SEM_PRAZO: { emoji: "⚪", label: "Sem prazo", className: "bg-muted text-muted-foreground" },
    DENTRO_PRAZO: { emoji: "🟢", label: "Dentro do prazo", className: "bg-success/10 text-success" },
    PROXIMO_VENCIMENTO: { emoji: "🟡", label: "Próximo do vencimento", className: "bg-amber-100 text-amber-700" },
    VENCIDO: { emoji: "🔴", label: "Prazo vencido", className: "bg-destructive/10 text-destructive" },
};

function formatarHoras(horas) {
    const abs = Math.abs(horas);
    const dias = Math.floor(abs / 24);
    const horasResto = Math.round(abs - dias * 24);
    return dias > 0 ? `${dias}d ${horasResto}h` : `${Math.round(abs)}h`;
}

// Texto curto pro badge ("Restam 3h" / "Vencido há 2d 1h").
export function textoRestante(prazo) {
    if (!prazo || prazo.horasRestantes == null) return null;
    return prazo.horasRestantes < 0
        ? `Vencido há ${formatarHoras(prazo.horasRestantes)}`
        : `Restam ${formatarHoras(prazo.horasRestantes)}`;
}

// Tooltip completo, com os 5 dados pedidos: prazo configurado, início, vencimento, restante e status.
export function tituloPrazo(prazo) {
    const info = STATUS_INFO[prazo?.status] || STATUS_INFO.SEM_PRAZO;
    if (!prazo || prazo.status === "SEM_PRAZO") {
        return "Sem prazo configurado para esta etapa";
    }
    const linhas = [
        // Sem prazoHoras = data-limite fixa (ex.: Confirmação de Pagamento vence no vencimento, às 17h).
        prazo.prazoHoras != null ? `Prazo: ${prazo.prazoHoras}h` : "Prazo: data de vencimento",
        `Início: ${formatarDataHora(prazo.dataInicio)}`,
        `Vencimento: ${formatarDataHora(prazo.dataLimite)}`,
        textoRestante(prazo),
        `Status: ${info.label}`,
    ].filter(Boolean);
    return linhas.join("\n");
}

export default function PrazoBadge({ prazo, compacto = false }) {
    const info = STATUS_INFO[prazo?.status] || STATUS_INFO.SEM_PRAZO;
    const texto = compacto ? info.label : (textoRestante(prazo) || info.label);

    return (
        <span
            title={tituloPrazo(prazo)}
            className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap ${info.className}`}
        >
            <span aria-hidden="true">{info.emoji}</span>
            {texto}
        </span>
    );
}
